
export class HolidayProperty {
  public name: string;
  public fromDate: Date; // "yyyy-MM-dd"
  public toDate: Date; // "yyyy-MM-dd"
}
